import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["default", "confirm", "label", "record", "form"]

  connect() {
    this.resetHandler = this.reset.bind(this)
    window.addEventListener("inline-confirm:reset", this.resetHandler)
    this.handleSubmitEnd = this.handleSubmitEnd.bind(this)
    if (this.hasFormTarget) {
      this.formTarget.addEventListener("turbo:submit-end", this.handleSubmitEnd)
    }
  }

  disconnect() {
    window.removeEventListener("inline-confirm:reset", this.resetHandler)
    if (this.hasFormTarget) {
      this.formTarget.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
    }
  }

  open(event) {
    event.preventDefault()
    const url = event.currentTarget.dataset.confirmUrl
    if (this.hasFormTarget && url) {
      this.formTarget.action = url
    }
    const recordShown = this.showRecord(event.currentTarget)
    if (this.hasRecordTarget && !recordShown) return

    this.toggle(true)
    this.toggleContext(true)
  }

  cancel(event) {
    event.preventDefault()
    this.toggle(false)
    this.toggleContext(false)
    this.resetRecord()
  }

  confirm(event) {
    event.preventDefault()
    if (this.hasFormTarget) {
      this.formTarget.requestSubmit()
      return
    }

    this.toggle(false)
    this.toggleContext(false)
    event.currentTarget.form?.requestSubmit()
  }

  toggle(showConfirm) {
    if (this.hasDefaultTarget) {
      this.defaultTarget.classList.toggle("tw-hidden", showConfirm)
    }
    if (this.hasConfirmTarget) {
      this.confirmTarget.classList.toggle("tw-hidden", !showConfirm)
    }
    if (this.hasLabelTarget) {
      this.labelTarget.classList.toggle("tw-hidden", !showConfirm)
    }
  }

  toggleContext(show) {
    const sidenavContent = document.getElementById("sidenav_content")

    if (sidenavContent) {
      sidenavContent.classList.toggle("sidenav-confirm-centered", show)
    }
  }

  handleSubmitEnd(event) {
    if (!event.detail.success) return
    this.toggle(false)
    this.toggleContext(false)
  }

  showRecord(trigger) {
    if (!this.hasRecordTarget) return true
    const recordDomId = trigger.dataset.confirmDomId
    if (!recordDomId) return false

    const recordFrame = document.getElementById(recordDomId)
    const recordSelector = trigger.dataset.confirmSelector || ".record-card"
    const recordCard = recordFrame?.querySelector(recordSelector)
    if (!recordCard) return false

    const clone = recordCard.cloneNode(true)
    const actions = clone.querySelector(".info.record-action")
    if (actions) actions.remove()
    clone.querySelector(".record-card-more-actions")?.remove();

    this.recordTarget.innerHTML = ""
    this.recordTarget.appendChild(clone)
    return true
  }

  resetRecord() {
    if (!this.hasRecordTarget) return
    this.recordTarget.innerHTML = ""
  }

  reset() {
    this.toggle(false)
    this.toggleContext(false)
    this.resetRecord()
  }
}
